// components/GlobalSearch.tsx
import { FC, useEffect, useRef } from 'react'
import classNames from 'classnames'
import styles from './GlobalSearch.module.scss'
import { CloseIcon } from 'shared/assets/icons'
import { useDebounce } from 'shared/hooks/Debounce/useDebounce'
import { useNavigate } from 'react-router-dom'

interface Props {
  isSearch: boolean
  setIsSearch: (val: boolean) => void
  searchValue: string
  setSearchValue: (val: string) => void
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void
}

const GlobalSearch: FC<Props> = ({ isSearch, setIsSearch, searchValue, setSearchValue, onSubmit }) => {
  const ref = useRef<HTMLDivElement | null>(null)

  const navigate = useNavigate()

  const debouncedSearchValue = useDebounce(searchValue, 600)

  useEffect(() => {
    if (debouncedSearchValue.trim()) {
      if (searchValue.trim().length) {
        navigate(`/products?search=${searchValue}`)
      }
      else {
        navigate('/products')
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedSearchValue, searchValue])

  // Закрытие при клике вне блока
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        setIsSearch(false)
        setSearchValue('')
      }
    }

    if (isSearch) {
      document.addEventListener('mousedown', handleClickOutside)
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSearch])

  return (
    <div
      ref={ref}
      className={classNames(styles.searchOverlay, {
        [styles.searchOverlayActive]: isSearch,
      })}
    >
      <form onSubmit={onSubmit} className={styles.searchForm}>
        <input
          type='text'
          autoFocus
          placeholder='Введіть назву товару або артикул...'
          value={searchValue}
          onChange={e => setSearchValue(e.target.value)}
        />
      </form>
      <button type='button' onClick={() => setIsSearch(false)} className={styles.closeButton}>
        <CloseIcon />
      </button>
    </div>
  )
}

export default GlobalSearch
